

export const displayNameSplite = (displayName) =>{
    const tab = displayName.split(' ');
    const lastName = tab[0];
    const firstName = tab?.at(1) || '';

    return { lastName, firstName };
}